<template>
  <div class="container">
    <div class="btn-back" @click="handleBack">返回</div>
    <div class="row1">
      <div class="area-title mg-bottom">
        <span>设定端口</span>
      </div>
      <div class="row-flex mg-bottom">
        <div class="left-flex">
          <div class="img-box">
            <img src="../../assets/blue.png" alt="" />
          </div>
          <div class="word-box">
            <p style="margin-bottom: 6px; color: #fff; font-size: 14px">
              集中式端口数
            </p>
            <p style="color: #E690FD; font-size: 18px; font-weight: bold">
              {{ portSum }}个
            </p>
          </div>
        </div>
        <div class="right-flex">
          <div class="word-box">
            <p style="margin-bottom: 6px; color: #fff; font-size: 14px">
              分布式端口数
            </p>
            <p style="color: #f9c32b; font-size: 18px; font-weight: bold">
              {{distributionPort}}个
            </p>
          </div>
          <div class="img-box" style="margin-left: 10px">
            <img src="../../assets/yellow.png" alt="" />
          </div>
        </div>
      </div>
      <div class="chart">
        <div id="chart" ref="main" style="width: 100%; height: 60px"></div>
      </div>
    </div>
    <div class="row2">
      <div class="area-title mg-bottom">
        <span>近七日充电服务类型</span>
      </div>
      <div class="area-bg">
        <div class="w-color fiexd1">{{ timeCharging }}%</div>
        <div class="w-color fiexd2">{{ moneyCharging }}%</div>
        <div class="w-color fiexd3">
          {{intelligenceCharging}}%
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      echartArea: null,
      timer:null,
      timeCharging:0,
      moneyCharging:0,
      intelligenceCharging:0,
      distributionPort:0,
      portSum:0,
      centreSocketRate:0
    };
  },
  props: {
    regionId:'',
    level:''
  },
  created() {
    this.timer = setInterval(() => {
      // setTimeout(this.getSouceData(), 0);
    }, 1000 * 10);
  },
  beforeDestroy() {
    clearInterval(this.timer);
    this.timer = null;
  },
  mounted() {
    this.initChart();
    this.getoption3DataType();
    this.getoption3DataPort();
  },
  methods: {
    handleBack() {
      this.$router.push({
        path: "/home",
      });
    },
    getSouceData(){
      this.getoption3DataType();
      this.getoption3DataPort();
    },
    initChart() {
      this.echartArea = this.$echarts.init(this.$refs.main);
    },
    // 组件3的数据源 近7日充电服务类型接口
    getoption3DataType() {
      this.$http({
        url: this.$http.adornUrl("/admin/api/busi/stat/dailyChargingOrderType"),
        method: "get",
        params: this.$http.adornParams({
          level: this.level,
          regionId: this.regionId,
        }),
      }).then(({ data }) => {
        console.log(data,'充电服务类型')
        if (data.code == 0) {
          this.timeCharging = data.data.fixedTimePro;
          this.moneyCharging = data.data.fixedAmountPro;
          this.intelligenceCharging = data.data.intellectChargePro;
          
        }
      });
    },
    // 组件3的数据源 设备端口
    getoption3DataPort(){
      this.$http({
        url: this.$http.adornUrl("/admin/api/busi/stat/bicycleSocketTypeNum"),
        method: "get",
        params: this.$http.adornParams({
          level: this.level,
          regionId: this.regionId,
        }),
      }).then(({ data }) => {
        console.log(data,'data11111jizhongshu')
        if (data.code == 0) {
          this.distributionPort = data.data.distributedSocketNumber;
          this.portSum = data.data.centreSocketNumber;
          this.centreSocketRate = data.data.centreSocketRate;
          this.updatedChart();
        }
      });
    },
    updatedChart() {
      var data = this.centreSocketRate; //百分比
      const option = {
        tooltip: {
          trigger: "none",
        },
        yAxis: {
          data: ["百分比"],
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
          },
          axisLabel: {
            show: false,
          },
        },
        xAxis: {
          splitLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
          },
          axisLabel: {
            show: false,
          },
        },
        legend: {
          show: false,
          data: ["底部立体柱", "上部立体柱"],
          bottom: "42%",
          textStyle: {
            color: "#1FC3CE",
            fontSize: 14,
          },
        },
        series: [
          {
            // name: '最上层立体圆',
            type: "pictorialBar",
            symbolSize: [10, 30],
            symbolOffset: [2, 0],
            z: 12,

            itemStyle: {
              normal: {
                color: "#F7B500",
              },
            },
            data: [
              {
                value: 100,
                symbolPosition: "end",
              },
            ],
          },
          {
            // name: '中间立体圆',
            type: "pictorialBar",
            symbolSize: [10, 30],
            symbolOffset: [2, 0],
            z: 120,
            itemStyle: {
              normal: {
                color: "#B687F9",
              },
            },
            data: [
              {
                value: data,
                symbolPosition: "end",
              },
            ],
          },
          {
            // name: '最底部立体圆',
            type: "pictorialBar",
            symbolSize: [10, 30],
            symbolOffset: [-4, 0],
            z: 12,
            itemStyle: {
              normal: {
                color: "#A052FE",
              },
            },
            data: [100 - data],
          },
          {
            name: "底部立体柱",
            //底部立体柱
            stack: "1",
            type: "bar",
            itemStyle: {
              normal: {
                color: this.$echarts.graphic.LinearGradient(0, 0, 1, 0, [
                  {
                    offset: 0,
                    color: "#CE7EFE",
                  },
                  {
                    offset: 1,
                    color: "#7125FF",
                  },
                ]),
              },
            },
            label: {
              normal: {
                show: true,
                position: "inside",
                offset: [0, 0],
                formatter: function (obj) {
                  return obj.value.toLocaleString() + "%";
                },
                textStyle: {
                  align: "center",
                  baseline: "middle",
                  fontSize: 14,
                  fontWeight: "400",
                  color: "#fff",
                  textShadowColor: "#000",
                  textShadowBlur: "0",
                  textShadowOffsetX: 1,
                  textShadowOffsetY: 1,
                },
              },
            },

            silent: true,
            barWidth: 30,
            barGap: "-100%", // Make series be overlap
            data: [data],
          },
          {
            name: "上部立体柱",
            //上部立体柱
            stack: "1",
            type: "bar",
            itemStyle: {
              normal: {
                color: "#F7B500",
                opacity: 0.7,
              },
            },
            silent: true,
            barWidth: 30,
            barGap: "-100%", // Make series be overlap
            data: [100 - data],
            // itemStyle: {
            //     normal: {
            //         color: 'rgba(29,67,243,1)',
            //     }
            // },
            label: {
              normal: {
                show: true,
                position: "inside",
                offset: [0, 0],
                formatter: function (obj) {
                  return obj.value.toLocaleString() + "%";
                },
                textStyle: {
                  align: "center",
                  baseline: "middle",
                  fontSize: 14,
                  fontWeight: "400",
                  color: "#fff",
                  textShadowColor: "#000",
                  textShadowBlur: "0",
                  textShadowOffsetX: 1,
                  textShadowOffsetY: 1,
                },
              },
            },
          },
        ],
      };
      this.echartArea.setOption(option);
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  position: relative;
  .btn-back {
    width: 115px;
    height: 35px;
    text-align: center;
    line-height: 35px;
    letter-spacing: 6px;
    background: rgba(0, 53, 178, 0.3);
    box-shadow: 0px 0px 3px 0px rgba(0, 150, 255, 0.6);
    border-radius: 20px;
    border: 1px solid #5284e0;
    position: absolute;
    right: 10px;
    top: -30px;
  }
}
.row1 {
  width: 100%;
  height: 210px;
}
.row-flex {
  display: flex;
  justify-content: space-between;
  .img-box {
    width: 50px;
    height: 50px;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
.left-flex,
.right-flex {
  display: flex;
  .word-box {
    margin-left: 10px;
  }
}
.area-title {
  width: 284px;
  height: 32px;
  background: url("../../assets/pgzl-ranking-bg.png");
  background-size: cover;
  background-position: center center;
  color: #fff;
  font-size: 14px;
  line-height: 32px;
  span {
    margin-left: 40px;
  }
}
.mg-bottom {
  margin-bottom: 30px;
}
.area-bg {
  width: 100%;
  height: 185px;
  background-image: url("../../assets/pagoda-bg.png");
  background-size: 100% 100%;
  position: relative;
  .w-color {
    font-size: 16px;
    color: #fff;
    font-weight: bold;
  }
  .fiexd1 {
    position: absolute;
    left: 95px;
    top: 25px;
  }
  .fiexd2 {
    position: absolute;
    left: 105px;
    top: 80px;
  }
  .fiexd3 {
    position: absolute;
    left: 110px;
    top: 150px;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/bicycle-system/option3.vue